"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAcceptedGigs = getAcceptedGigs;
exports.getAcceptedGigsCount = getAcceptedGigsCount;
const baseUrls_1 = require("./baseUrls");
const fetchWrapper_1 = require("./fetchWrapper");
const getGigDetailsByGigId_1 = require("./getGigDetailsByGigId");
async function getAcceptedGigs(authConfig) {
    const headers = {
        Authorization: `${authConfig.authType} ${authConfig.value}`,
    };
    const acceptedGigsResponse = await (0, fetchWrapper_1.fetchWrapper)(`${baseUrls_1.ApiBaseUrl}/getListOfGigsAndProjectsAcceptedByUser`, {
        method: 'GET',
        headers: headers,
    });
    const acceptedGigs = acceptedGigsResponse.data;
    const acceptedGigsWithDetails = [];
    for (let index = 0; index < acceptedGigs.length; index++) {
        const { gigId } = acceptedGigs[index];
        const gigDetailsResponse = await (0, getGigDetailsByGigId_1.getGigDetailsByGigId)(gigId);
        const gigDetailsData = gigDetailsResponse.data;
        acceptedGigsWithDetails.push(gigDetailsData[0]);
    }
    return acceptedGigsWithDetails;
}
async function getAcceptedGigsCount(authHeader) {
    const headers = {
        Authorization: authHeader,
    };
    const acceptedGigsResponse = await (0, fetchWrapper_1.fetchWrapper)(`${baseUrls_1.ApiBaseUrl}/getListOfGigsAndProjectsAcceptedByUser`, {
        method: 'GET',
        headers: headers,
    });
    const acceptedGigs = acceptedGigsResponse.data;
    return acceptedGigs.length;
}
